
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import PushNotification from './PushNotification';
import './style.sass'



const PushNotificationContainer = () => {

    const pushNotifications = useSelector(({ notification }) => notification.pushNotifications);

    return (
        <div className="notification-container">
            {pushNotifications && pushNotifications.map((notification, key) => <PushNotification key={key} item={notification} />)}
        </div>
    );
}


export default PushNotificationContainer